import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import GitHubRepos from "./github";
import MediumBlog from "./medium";

export const Projects = () => {
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                {/* <h2>Projects</h2>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p> */}
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Projects</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Blogs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">About Me</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <p>In this section, you’ll find a collection of the projects I’ve worked on. Each project showcases my skills, creativity, and ability to tackle unique challenges.</p>
                      <GitHubRepos />
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p>I love sharing my thoughts and experiences with the world, whether it's about technology, development, or personal growth. In this section, you'll my blog posts where I dive into the latest trends in tech, explore and explain new concepts, and reflect on my journey.</p>
                      <MediumBlog/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <p>Hi! I'm a Computer Science Engineering student at IIIT Sri City, deeply passionate about Machine Learning (ML), Deep Learning (DL), and Natural Language Processing (NLP). I love exploring how intelligent systems can solve real-world problems, and I've spent the last few years building, training, and fine-tuning models across a wide range of use cases.</p>

<p>From foundational techniques like regression and decision trees to advanced neural architectures such as CNNs, RNNs, LSTMs, and transformer-based models (BERT, GPT), I’ve worked hands-on to turn theory into practical solutions. Recently, I’ve been diving into the world of Large Language Models (LLMs)—studying everything from pretraining and instruction tuning to RLHF and modern fine-tuning techniques like LoRA and QLoRA.</p>

<p>In parallel with my academic journey, I’ve gained industry experience through a technical internship where I built end-to-end NLP pipelines, automated content tagging, and developed domain-specific scoring models. This experience helped me bridge the gap between research and real-world impact, sharpening my skills in problem-solving, collaboration, and delivering under deadlines.</p>

<p>I’m also actively involved in research and innovation, currently working on projects in sentiment analysis and recommendation systems under a structured academic program. One of my key focuses has been building a custom BERT-based architecture to generate more context-aware and interpretable embeddings for downstream tasks.</p>

<p>My curiosity doesn’t stop at model development—I’m also exploring MLOps and LLMOps, with hands-on work in Docker, MLflow, cloud deployment, and ETL pipelines to make AI workflows more production-ready and scalable.</p>

<p>Outside of work and academics, I enjoy mentoring and sharing knowledge. I lead Machine Learning initiatives in campus tech communities, helping students get started with ML, organizing events, and fostering a collaborative, growth-oriented ecosystem.</p>

<p>Whether it's scaling a model, experimenting with new architectures, or turning raw data into actionable insights—I’m always excited to take on the next challenge.</p>

                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
